import React from "react"
import {
  ListProps,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  makeStyles,
  Theme,
} from "@material-ui/core"
import { Skeleton } from "@material-ui/lab"

interface LoadingListProps extends ListProps {
  nested?: boolean
  secondary?: boolean
  icon?: boolean
}

/** Scoped @material-ui/core stylesheet */
const useStyles = makeStyles<Theme>(theme => ({
  root: {
    maxWidth: theme.spacing(75),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  listItemText: {
    "& .MuiListItemText-primary,.MuiListItemText-secondary": {
      width: "100%",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },
  },
}))

export const LoadingList: React.FC<LoadingListProps> = ({
  nested = true,
  secondary = true,
  icon = true,
}) => {
  /** Get scoped CSS classes */
  const classes = useStyles()

  return (
    <List className={classes.root}>
      <ListItem>
        {icon && (
          <ListItemIcon>
            <Skeleton variant="circle" width={32} height={32} />
          </ListItemIcon>
        )}
        <ListItemText
          primary={<Skeleton width={120} height={24} />}
          secondary={
            nested || !secondary ? (
              undefined
            ) : (
              <Skeleton width={180} height={21} />
            )
          }
        />
      </ListItem>
      <List>
        <ListItem className={nested ? classes.nested : undefined}>
          {icon && (
            <ListItemIcon>
              <Skeleton variant="circle" width={32} height={32} />
            </ListItemIcon>
          )}
          <ListItemText
            primary={<Skeleton width={120} height={24} />}
            secondary={secondary && <Skeleton width={180} height={21} />}
          />
        </ListItem>
        <ListItem className={nested ? classes.nested : undefined}>
          {icon && (
            <ListItemIcon>
              <Skeleton variant="circle" width={32} height={32} />
            </ListItemIcon>
          )}
          <ListItemText
            primary={<Skeleton width={120} height={24} />}
            secondary={secondary && <Skeleton width={180} height={21} />}
          />
        </ListItem>
      </List>
    </List>
  )
}
